import FadeAnimation from "./FadeAnimation";
import WipeAnimation from "./WipeAnimation";

function getInstanceAnimationByType(type) {
  switch (type) {
    case 'wipe':
      return WipeAnimation;
    default:
      return FadeAnimation;

  }
}

export default function initAnimation(animations = [], object) {

  return animations.map((animation) => {
    const instance = getInstanceAnimationByType(animation.type);

    return new instance(animation, object);
  })
}